import { Component } from '@angular/core';

@Component({
  selector: 'app-callback-errors',
  templateUrl: './callback-errors.component.html',
  standalone: false,
})
export class CallbackErrorsComponent {}
